import React from "react";
import { FiInbox, FiPlus } from "react-icons/fi";

// Type-safe icon wrappers
const InboxIcon = FiInbox as React.FC<React.SVGProps<SVGSVGElement>>;
const PlusIcon = FiPlus as React.FC<React.SVGProps<SVGSVGElement>>;

interface WorkflowEmptyStateProps {
  onCreateWorkflow: () => void;
}

const WorkflowEmptyState: React.FC<WorkflowEmptyStateProps> = ({
  onCreateWorkflow,
}) => {
  return (
    <div className="su-workflow-empty-state">
      <div className="su-workflow-empty-icon">
        <InboxIcon className="w-12 h-12" />
      </div>
      <h3 className="su-workflow-empty-title">No scheduled workflows yet</h3>
      <p className="su-workflow-empty-subtitle">
        Create your first workflow to automate your updates
      </p>
      <button
        className="su-btn su-btn-purple su-btn-lg su-workflow-empty-cta"
        onClick={onCreateWorkflow}
      >
        <PlusIcon className="w-5 h-5" />
        <span>Create Workflow</span>
      </button>
    </div>
  );
};

export default WorkflowEmptyState;



